import { FC } from 'react'
import styled from '@emotion/styled'

import { LibAnchor, TLibAnchor, TLibAnchorStyles } from 'ui-components'

const StyledAnchor = styled.a<TLibAnchorStyles>`
    cursor: pointer;
    outline: none;

    font-weight: ${({ isBold }) => (isBold ? 'bold' : 'normal')};
    color: ${({ isColorized, theme }) =>
        isColorized ? theme.colors.primary : theme.colors.secondary};
`

type TAnchor = TLibAnchor & TLibAnchorStyles

const Anchor: FC<TAnchor> = ({ href, ...props }) => (
    <LibAnchor href={href} StyledAnchor={StyledAnchor} {...props} />
)

export default Anchor
